module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"filename asc":"Dateiname aufsteigend","filename desc":"Dateiname absteigend","label":"Label","order by":"Sortieren nach","name":"Name"}}')
  delete Component.options._Ctor
}
